import { useCallback } from "react";
import { axiosPrivate } from "../../../api/axios";

export const useProjectApi = (groupCode, projectCode) => {
  const makeRequest = useCallback(
    (method, endpoint, data = null) => {
      const fullUrl = `/risk/${groupCode}/${projectCode}${endpoint}`;
      // Override the client's JSON default; Axios supplies the multipart boundary.
      if ((method === "post" || method === "put") && data instanceof FormData) {
        return axiosPrivate[method](fullUrl, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }
      return axiosPrivate[method](fullUrl, data);
    },
    [groupCode, projectCode]
  );

  return {
    get: (endpoint, data) => makeRequest("get", endpoint, data),
    post: (endpoint, data) => makeRequest("post", endpoint, data),
    put: (endpoint, data) => makeRequest("put", endpoint, data),
    delete: (endpoint, data) => makeRequest("delete", endpoint, data),
  };
};
